import { getAssetsUrlWithHttp, resolveAssetImage } from "@/utils/common"
import { formatCurrency } from "@/utils/format"
import styled from "@emotion/styled"
import DepositBlockTitle from "./DepositBlockTitle"
import { openExternalLink } from "@/utils/openExternalLink"

const Container = styled.div`
    height: 148rem;
    background-repeat: none;
    background-position: center;
    background-size: cover;
    margin-left: 12rem;
    margin-right: 12rem;
    padding: 12rem;
    border-radius: 12rem;
    overflow: hidden;
`

const VoucherContainer = styled.div`
    display: flex;
    gap: 7rem;
    overflow-x: auto;
    white-space: nowrap;
    &::-webkit-scrollbar {
        height: 0;
        background: transparent;
        opacity: 0;
    }
`

const VoucherWrap = styled.div`
    flex: 0 0 auto;
    width: 64rem;
    height: 88rem;
    border-radius: 8rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
`
const Voucher = styled.img`
    width: 64rem;
    height: 64rem;
    object-fit: cover;
`

const VoucherAmount = styled.div`
    color: #ff536c;
    font-size: 12rem;
    font-style: normal;
    font-weight: 510;
    height: 16rem;
    line-height: 16rem;
    margin-top: 4rem;
    white-space: nowrap;
`

const Empty = styled.img`
    width: 120rem;
    height: 76rem;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20rem;
`
interface LaCode {
    name: string
    price: string
    img: string
    link: string
}

export default function LaVoucher({ list = [] }: { list: LaCode[] }) {
    return (
        <Container
            css={`
                background-image: url(${resolveAssetImage(
                    "pages/UserCenterPage/deposit/lazada_bg.webp",
                )});
            `}
        >
            <DepositBlockTitle>Lazada Voucher Code</DepositBlockTitle>
            {list.length > 0 ? (
                <VoucherContainer>
                    {list.map((item, idx) => {
                        return (
                            <VoucherWrap key={`voucher_${idx}`}>
                                <Voucher
                                    src={getAssetsUrlWithHttp(item.img)}
                                    alt=""
                                    onClick={() => {
                                        if (item.link) {
                                            openExternalLink(item.link)
                                        }
                                    }}
                                />
                                <VoucherAmount>
                                    {formatCurrency(parseFloat(item.price) || 0)}
                                </VoucherAmount>
                            </VoucherWrap>
                        )
                    })}
                </VoucherContainer>
            ) : (
                <Empty src={resolveAssetImage("pages/UserCenterPage/deposit/lazada_empty.webp")} />
            )}
        </Container>
    )
}
